'use strict'

export default typeof Blob !== 'undefined' ? Blob : null



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/Blob.js
// module id = JB2u
// module chunks = 4